export default __webpack_public_path__ + "static/media/shengshi-logo.9441ca39.svg";